import {
  compose,
  withProps,
  branch,
} from 'recompose';
import { isNoIndex } from './WithNoIndex';

const updateOrCreateCanonicalLink = () => {
  const href = `${window.location.protocol}//${window.location.host}${window.location.pathname}`.replace(/\/$/, "");
  const canonical = document.querySelector('link[rel="canonical"]');
  if (canonical) {
    canonical.setAttribute('href', href);
  } else {
    const link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', href);
    document.head.appendChild(link);
  }
};

const removeCanonicalLink = () => {
  const tag = document.querySelector('link[rel="canonical"]');
  tag && tag.remove();
};

export const withSelfCanonicalRef = compose(
  branch(
    isNoIndex,
    withProps(({ callbacks }) => ({
      callbacks: [...callbacks, removeCanonicalLink]
    })),
    withProps(({ callbacks }) => ({
      callbacks: [
        ...callbacks,
        updateOrCreateCanonicalLink]
    })),
  )
);



// WEBPACK FOOTER //
// ./src/Common/Helmet/WithSelfCanonicalRef.js